<template>
    <div class="flex sm:flex-col md:flex-row  items-center h-32   bg-gray-400  px-8"> 
         <div>  
             <img
                    :src="showImage() "
                    class="object-cover h-16 max-w-96"
                /> </div>
         <!-- <div class="mx-auto text-white text-3xl font-extrabold"> Bernstein Badshop</div>  -->
         <div > </div> 
    </div>

</template> 

<script>
import AppLayout from '../Layouts/AppLayout.vue'
export default {
  components: { AppLayout }, 
    methods:{
        showImage(){
            return "/storage/images/bernstein-logo.svg"
        }
    }
}
</script>